/* eslint-disable no-param-reassign */
/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
import { set } from 'lodash-es';

import {
  addPaymentMethod as _addPaymentMethod,
  addPaymentMethodIban as _addPaymentMethodIban,
  createGoCardlessBankAccount,
  getGoCardlessBankAccounts,
  deleteGoCardlessBankAccount,
  activateGoCardlessBankAccount,
} from '@/services/api/payment/transactions';

// TODO implémenter ces routes dans le widget
import {
  getPaymentMethods as _getPaymentMethods,
  deletePaymentMethodFromId as _deletePaymentMethod,
  activatePaymentMethodFromId as _activatePaymentMethodFromId,
} from '@/services/api/payment/payment';

import {
  createStripeReference as _createStripeReference,
} from '@/services/api/customer/company';

// initial state
const state = {
  paymentMethods: [],
  goCardlessBankAccounts: [],
  accountOwner: null,
  stripePaymentExternalReference: null,
};

// getters
const getters = {
  paymentMethods: (state) => state.paymentMethods,
  paymentMethod: (state) => state.paymentMethods
    .find(({ active }) => active),
  goCardlessBankAccounts: (state) => Array.isArray(state.goCardlessBankAccounts) ? state.goCardlessBankAccounts : [],
  accountOwner: (state) => state.accountOwner,
};

// actions
const actions = {
  async setExternal({ commit }, stripePaymentExternalReference) {
    if (stripePaymentExternalReference) {
      commit('SET_VALUE', { stripePaymentExternalReference });
    }
  },
  // eslint-disable-next-line no-unused-vars
  async createStripeReference({ rootGetters, state, commit }) {
    if (state.stripePaymentExternalReference === null) {
      const companyId = rootGetters['company/companyId'];
      const { data: company } = await _createStripeReference(companyId);
      commit('SET_VALUE', {
        stripePaymentExternalReference: company.stripePaymentExternalReference,
      });
    }
  },
  async getPaymentMethods({ commit, rootGetters }) {
    const companyId = rootGetters['company/get'].id;
    if (companyId) {
      const { data: paymentMethods } = await _getPaymentMethods(companyId);
      commit('SET_VALUE', { paymentMethods: paymentMethods || [] });
      return paymentMethods;
    }
    return Promise.resolve();
  },
  addCreditCard({ rootGetters }, [stripe, container]) {
    const companyId = rootGetters['company/get'].id;
    return _addPaymentMethod(stripe, container, companyId);
  },
  addIban({ rootGetters, state }, [stripe, container]) {
    const companyId = rootGetters['company/get'].id;
    const { email: contactEmail } = rootGetters['client/get'];
    const customerName = state.accountOwner;
    return _addPaymentMethodIban(stripe, container, companyId, { contactEmail, customerName });
  },
  async removePaymentMethod({ rootGetters, state, commit }, id) {
    const companyId = rootGetters['company/companyId'];
    await _deletePaymentMethod(companyId, id);
    const paymentMethods = state.paymentMethods
      .filter(({ id: paymentMethodId }) => id !== paymentMethodId)
      || [];
    commit('SET_VALUE', { paymentMethods });
  },
  async activatePaymentMethodFromId({ rootGetters, dispatch }, id) {
    const companyId = rootGetters['company/get'].id;
    await _activatePaymentMethodFromId(companyId, id);
    return dispatch('getPaymentMethods');
  },
  /**
   ** Set a value in store with path
   * @param {Object} insert { path, value } in state
   */
  setValueWithPath({ commit }, object) {
    commit('setValueWithPath', object);
  },
  clear({ commit }) {
    commit('CLEAR');
  },

  async createGoCardlessBankAccount({ rootGetters, dispatch }, payload) {
    const companyId = rootGetters['company/get'].id;
    const result = await createGoCardlessBankAccount(companyId, payload);
    await dispatch('getGoCardlessBankAccounts');
    return result;
  },

  async getGoCardlessBankAccounts({ commit, rootGetters }) {
    const companyId = rootGetters['company/get'].id;
    if (companyId) {
      const { data: bankAccounts } = await getGoCardlessBankAccounts(companyId);
      commit('SET_VALUE', { goCardlessBankAccounts: bankAccounts || [] });
      return bankAccounts;
    }
    return Promise.resolve([]);
  },

  async deleteGoCardlessBankAccount({ rootGetters, dispatch }, accountId) {
    const companyId = rootGetters['company/get'].id;
    const result = await deleteGoCardlessBankAccount(companyId, accountId);
    await dispatch('getGoCardlessBankAccounts');
    return result;
  },

  async activateGoCardlessBankAccount({ dispatch }, accountId) {
    const result = await activateGoCardlessBankAccount(accountId);
    await dispatch('getGoCardlessBankAccounts');
    return result;
  },
};

// mutations
const mutations = {
  CLEAR(state) {
    Object.assign(state, {
      id: '',
      delegation: true,
      totalToPay: 0,
    });
  },
  SET_VALUE(state, object) {
    const [key] = Object.keys(object);
    Object.assign(state, { [key]: object[key] });
  },
  SET_CHECKOUT(state, values) {
    Object.assign(state, { ...values });
  },
  setValueWithPath(state, { value, path }) {
    set(state, path, value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
